<template>
  <div class="animated fadeIn">
    <div class="form-group row pt-2 pb-4">
      <div class="col-md-12">
        <label for="txtGroup"
          ><small
            class="text-danger"
            v-if="form.responsaveis.required"
            >*</small
          >Selecione os Responsáveis:</label
        >
        <div class="input-group">
          <v-select
            multiple
            v-model="form.responsaveis.value"
            :options="form.responsaveis.options"
            label="text"
            :reduce="(x) => x.value"
            class="w-100"
            :disabled = "notEdit === true"
          >
            <template v-slot:no-options
              >Nenhum Funcionário encontrado.</template
            >
          </v-select>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <label for="txtGroup"
          ><small
            class="text-danger"
            v-if="form.responsaveis.required"
            >*</small
          >Selecione os Grupos Responsáveis:</label
        >
        <div class="input-group">
          <v-select
            multiple
            v-model="form.gruposResponsaveis.value"
            :options="form.gruposResponsaveis.options"
            label="text"
            :reduce="(x) => x.value"
            class="w-100"
            :disabled = "notEdit === true"
          >
            <template v-slot:no-options
              >Nenhum Funcionário encontrado.</template
            >
          </v-select>
        </div>

        <div
          v-if="cardActive"
          class="form-group row pt-3"
        >
          <div
            v-if="notEdit === false"
            class="col-md-12"
            style="text-align: right"
          >
            <button
              type="button"
              class="btn btn-third rounded"
              v-on:click="onUpdateCard"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonSave"
            >
              <i class="fa fa-check-circle"></i>
              <span class="d-md-down-none">{{
                $lang.Common.Buttons.Save
              }}</span></button
            >&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CrmDetailsLeadOwner from './leadowner.js'
export default CrmDetailsLeadOwner
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/leadowner/leadowner.vue